import React, { useState, useEffect } from 'react';
import {Redirect} from 'react-router-dom';
import ProgramSelector from '../common/ProgramSelectorComp';
import ClassSelector from '../common/ClassSelectorComp';
import MainProgramTableComp from './MainProgramTableComp';
import MainStudentTableComp from './MainStudentTableComp';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReportWindowModal from './ReportWindowModal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { request, deleteThis } from '../../redux/actions/genericAction';
import StaticNav from '../common/StaticNav';
import axios from 'axios';
import { convertDictionaryKeys, isObjectEmpty, toArray, arrayToObject, removeDuplicates } from '../../Utils';
import { longButtonStyle, titleBarStyle, wizzardBarStyle } from '../common/theme';
import Alert from 'react-bootstrap/Alert';
import StudentReportTableComp from './StudentReportTableComp';
import ProgramReportTableComp from './ProgramReportTableComp';

function ReportsPage({isAdmin, database, request, deleteThis, programs}) {
  const [modalShow, setModalShow] = useState(false);
  const [hasDatabaseData, sethasDatabaseData] = useState(true);

//  const [selectedStudents, setSelectedStudents] = useState([{id:'139019', name:'Noah'},{id:'75189', name:'Jamie Whitten'},{id:'81068', name:'Brad'}] );
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState({});

  const [selectedStudent, setSelectedStudent] = useState({});
  // const [selectedPrograms, setSelectedPrograms] = useState([]);

  const [classID, setClassID] = useState('');
  const [currentCateg, setCurrentCateg] = useState('(K-3) Reading Programs');
  const [ownProgramsData, setOwnProgramsData] = useState({});
  const [categsData, setCategsData] = useState({});
  const [studentData, setStudentData] = useState([]);
  const [summaryRaw, setSummaryRaw] = useState([]);
  const [processedProgramSummary, setProcessedProgramSummary] = useState([]);
  const [processedStudentSummary, setProcessedStudentSummary] = useState([]);
  const [classData, setClassData] = useState([]);
  const [dateRange, setDateRange] = useState([]);

  let categoryTypes = [
    'Recently Used Programs','Assigned Programs','Student Assignments','Favorite Programs',
    '(K-3) Reading Programs','(4-6) Reading Programs','Reader Programs',
    '(K-3) Math Programs','(4-6) Math Programs','Mad Minute',
    'ESL Programs','Science and Geography Programs','User Programs','Student Marks'
  ];

  const pageState ={
    hasDatabaseData, sethasDatabaseData,
    processedProgramSummary, setProcessedProgramSummary,
    processedStudentSummary, setProcessedStudentSummary,
    database, request, deleteThis, programs,
    dateRange, setDateRange, 
    selectedProgram, setSelectedProgram, selectedStudents, setSelectedStudents,
    selectedStudent, setSelectedStudent,
    isAdmin, classID  
  };

  useEffect(()=>{
    if(!categsData[currentCateg] || categsData[currentCateg].length===0){
      let newCategory = categoryTypes.find(e=>(categsData[e] && categsData[e].length>0));
      setCurrentCateg(newCategory);
    }
  });

  const tryLoadingNow = () => {
    if(classID=='') return;
    if(isObjectEmpty(ownProgramsData)) return;
    if(!database['getAllTimeMarksForClassByDateRange'] || !database['getAllTimeMarksForClassByDateRange'].isLoaded) return;
    if(!database['getStudentsForClass'] || !database['getStudentsForClass'].isLoaded) return;
    if(isObjectEmpty(categsData)) return;

    // add program favorites to program group list
    let currentClass = classData.filter(e=>e.ClassID === classID)[0];
    let categories = {...categsData};

    if(currentClass.Favorites !=='' && categsData['Favorite Programs'].length === 0){
      let ownedPrograms = arrayToObject(toArray(database['getAllPrograms'].data),'NAME');
      let favPrograms = (currentClass.Favorites)?currentClass.Favorites
        .split(',')
        .map(e=>programs[e])
        .filter((progRec)=> progRec.id in ownedPrograms):[];

      categories['Favorite Programs'] = favPrograms;
    }

    // add recently used programs to group list
    let markPrograms = toArray(database['getAllTimeMarksForClassByDateRange'].data)
                        .map(e=>e.ProgID.toUpperCase())
                        .map(e=>programs[e])
                        .sort((a,b) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : (a.title.toUpperCase() < b.title.toUpperCase() ? -1 : 0))
                        .filter(e=> e !== undefined);
    categories['Recently Used Programs'] = removeDuplicates(markPrograms,'id');

    // if either favorite programs or recently used has changes then reset categories
    if(JSON.stringify(categories['Favorite Programs'])!==JSON.stringify(categsData['Favorite Programs']) || 
      JSON.stringify(categories['Recently Used Programs'])!==JSON.stringify(categsData['Recently Used Programs']))
      setCategsData(categories);

    // combine student marks per program
    let summaryData = toArray(summaryRaw.data).reduce((obj, item) => {
      let key = `${item['StudentID']}+${item['ProgID']}`; 
      if(key in obj){
        obj[key].QuestionsAttempted += parseInt(item.QuestionsAttempted);
        obj[key].QuestionsRight += parseInt(item.QuestionsRight);
        obj[key].timeSpent += parseInt(item.CumulativeTime) + parseInt(item.CumulativeIdleTime);
        obj[key].TimesMastered += parseInt(item.TimesMastered);
        if(obj[key].QuestionsAttempted !== 0){
          obj[key].score = Math.round(parseInt(obj[key].QuestionsRight)/parseInt(obj[key].QuestionsAttempted)*100);
        }
        else
          obj[key].score ='--';
          
        if(item.PrePer==='100')
          obj[key].hasFinishedPretest = true;
      }
      else{
        let score = '--';
        if(item.QuestionsAttempted!==0)
          score = Math.round(parseInt(item.QuestionsRight)/parseInt(item.QuestionsAttempted)*100);

        obj[key] = {
          QuestionsAttempted: parseInt(item.QuestionsAttempted), 
          QuestionsRight: parseInt(item.QuestionsRight), 
          timeSpent: parseInt(item.CumulativeTime)+parseInt(item.CumulativeIdleTime), 
          TimesMastered: parseInt(item.TimesMastered),
          score
        };
        if(item.PrePer==='100')
          obj[key].hasFinishedPretest = true;
      }
      return obj;
    }, {});

    if(currentCateg !=='Student Marks'){

      let processedPrograms = categsData[currentCateg].map(progRec=> {      
      let combined = { QuestionsAttempted: '--', QuestionsRight: '--', timeSpent: 0,TimesMastered: '--',score:'--'};
      if(progRec.id===selectedProgram.id) progRec.showStudents = true;

      let students = [...studentData].map(studRec=>{
          studRec.isSelected = false;
          let progID = progRec.id;//.toLowerCase();
          if(!(progID.startsWith('QUIZ') || progID.startsWith('LESSON') || progID.startsWith('COURSE'))) progID = progID.toLowerCase();
          let summary = (summaryData[`${studRec.StudentID}+${progID}`]) ? summaryData[`${studRec.StudentID}+${progID}`] : { QuestionsAttempted: '--', QuestionsRight: '--', timeSpent: 0,TimesMastered: '--',score:'--'}; 

          if(summary.QuestionsAttempted !=='--'){
            if(combined.QuestionsAttempted === '--'){
              combined.QuestionsAttempted = 0;
              combined.QuestionsRight = 0;
              combined.timeSpent = 0;
              combined.TimesMastered = 0;
            }
            combined.QuestionsAttempted += parseInt(summary.QuestionsAttempted);
            combined.QuestionsRight += parseInt(summary.QuestionsRight);
            combined.timeSpent += parseInt(summary.timeSpent);
            combined.TimesMastered += parseInt(summary.TimesMastered);
            if(combined.QuestionsAttempted !== 0){
              combined.score = Math.round(parseInt(combined.QuestionsRight)/parseInt(combined.QuestionsAttempted)*100);
            }
          }
          return {...studRec, ...summary};
        });
        return {...progRec, students, ...combined};
      });

      setProcessedProgramSummary(processedPrograms);
    }

    if(currentCateg ==='Student Marks'){
      let processedStudents = [...studentData].map(studRec=>{      
        let combined = { QuestionsAttempted: '--', QuestionsRight: '--', timeSpent: 0,TimesMastered: '--',score:'--'};
        if(studRec.StudentID===selectedStudent.id) studRec.showPrograms = true;

        let programs = categsData[currentCateg].map(progRec=> {
          // progRec.isSelected = false;
          let progID = progRec.id;//.toLowerCase();
          if(!(progID.startsWith('QUIZ') || progID.startsWith('LESSON') || progID.startsWith('COURSE'))) progID = progID.toLowerCase();

          let summary = (summaryData[`${studRec.StudentID}+${progID}`]) ? summaryData[`${studRec.StudentID}+${progID}`] : { QuestionsAttempted: '--', QuestionsRight: '--', timeSpent: 0,TimesMastered: '--',score:'--'}; 

          if(summary.QuestionsAttempted !=='--'){
            if(combined.QuestionsAttempted === '--'){
              combined.QuestionsAttempted = 0;
              combined.QuestionsRight = 0;
              combined.timeSpent = 0;
              combined.TimesMastered = 0;
            }
            combined.QuestionsAttempted += parseInt(summary.QuestionsAttempted);
            combined.QuestionsRight += parseInt(summary.QuestionsRight);
            combined.timeSpent += parseInt(summary.timeSpent);
            combined.TimesMastered += parseInt(summary.TimesMastered);
            if(combined.QuestionsAttempted !== 0){
              combined.score = Math.round(parseInt(combined.QuestionsRight)/parseInt(combined.QuestionsAttempted)*100);
            }
          }
          return {...progRec, ...summary};
        });
        return {...studRec, programs, ...combined};
      });

      setProcessedStudentSummary(processedStudents);
    }
  }; 

  useEffect(() =>{tryLoadingNow();},[summaryRaw]);
  useEffect(() =>{tryLoadingNow();},[studentData]);
  useEffect(() =>{tryLoadingNow();},[categsData]);  
  useEffect(()=> {tryLoadingNow();},[currentCateg]);
  useEffect(()=> {tryLoadingNow();},[classID]);
  useEffect(()=> {tryLoadingNow();},[ownProgramsData]);
  
  useEffect(() => {
    if(!database['getCustomer'])
      return sethasDatabaseData(false);

    if(!isObjectEmpty(ownProgramsData)) return; // already loaded this useeffect
    setOwnProgramsData(database['getAllPrograms'].data);

    let programs = toArray(pageState.programs);
    let ownedPrograms = arrayToObject(toArray(database['getAllPrograms'].data),'NAME');

    let categories = {
      '(K-3) Reading Programs': programs.filter((progRec)=>progRec.subcateg==='(K-3) Reading Programs' && progRec.id in ownedPrograms),
      '(4-6) Reading Programs': programs.filter((progRec)=>progRec.subcateg==='(4-6) Reading Programs' && progRec.id in ownedPrograms),
      '(K-3) Math Programs': programs.filter((progRec)=>progRec.subcateg==='(K-3) Math Programs' && progRec.id in ownedPrograms),
      '(4-6) Math Programs': programs.filter((progRec)=>progRec.subcateg==='(4-6) Math Programs' && progRec.id in ownedPrograms),
      'Science and Geography Programs': programs.filter((progRec)=>progRec.subcateg==='Science and Geography Programs' && progRec.id in ownedPrograms),
      'User Programs': programs.filter((progRec)=>progRec.categ==='User' && progRec.id in ownedPrograms),
      'ESL Programs': programs.filter((progRec)=>progRec.subcateg==='ELL Programs' && progRec.id in ownedPrograms),
      'Reader Programs': programs.filter((progRec)=>progRec.subcateg==='Reader Programs' && progRec.id in ownedPrograms),
      'Mad Minute': programs.filter((progRec)=>progRec.subcateg==='Mad Minute' && progRec.id in ownedPrograms),
      'Favorite Programs': [],
      'Recently Used Programs' : [],
    };

    // Add User Content as programs/Quizes
    if(database['getAllUserPrograms'] && database['getAllUserPrograms'].isLoaded && sessionStorage.getItem('productionPath')!=='0000000000000000'){
      categories['User Programs'] = Object.keys(database['getAllUserPrograms'].data).map((key,i)=>{
        const e = database['getAllUserPrograms'].data[key];
        
        let stringDate = (new Date(Number(e['LastUpdated']))).toLocaleString().split(',')[0];
        let author = 'Removed Teacher';
        if(database['getAllClasses'] && database['getAllClasses'].data[e['TeacherID']])
          author = database['getAllClasses'].data[e['TeacherID']].Classname;
        if(database['getCustomer'] && database['getCustomer'].data.ID===e['TeacherID'])
          author = 'Shared';

        return { 
          schoolID:e['SchoolID'],
          id: e['progID'].toUpperCase()+'-'+e['ContentID'],
          categ: 'User',
          gradeTitle: e['Title'],
          title: stringDate+' - '+author+' - '+e['Title'],
          shortTitle: e['ShortTitle'],
          modules:[[e['progID'].toUpperCase(),e['Description']]],
          order: i,
          suborder:3,
          subcateg: 'User Programs',
          authorID: e['TeacherID'],
          standard:e['Standard'],
          version:e['Version'],
          LastUpdated:e['LastUpdated'],
          Description:e['Description'],
          tags:e['Tags']
        };
      }).filter(item=> (item.title.indexOf('Removed Teacher'))===-1)
        .filter(item=> (isAdmin || item.authorID==classID || item.authorID==database['getCustomer'].data['ID']))
        .sort((b,a) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : (a.title.toUpperCase() < b.title.toUpperCase() ? -1 : 0));
    }

    //categories['Student Marks'] = toArray(categories).reduce((acc,e)=>{return [...acc, ...e];},[]);
    categories['Student Marks'] = [...programs];
    setCategsData(categories);
  });

  const getNewDate = () =>{
    let endDate = new Date();
    let startDate = new Date();
    
    startDate.setDate(endDate.getDate()-6);
    startDate.setHours(0,0,0,0);

    setDateRange([startDate.getTime(), endDate.getTime()]);
    return [startDate.getTime(), endDate.getTime()];
  }; 

  // reload class data when needed
  useEffect(()=>{
    if(classID=='') return;
    let tDateRange = (dateRange.length==0) ? getNewDate(): dateRange;

    if(!database['getAllTimeMarksForClassByDateRange']){
      let getStudentsForClassQuery={
        params: classID,
        func:'getStudentsForClass'            
      };

      let getAllTimeMarksForClassByDateRangeQuery={
        params: `${classID}~${tDateRange[0]}~${tDateRange[1]}`,
        altServer:true,
        func:'getAllTimeMarksForClassByDateRange',
        nextRequest: getStudentsForClassQuery           
      };
      request(getAllTimeMarksForClassByDateRangeQuery);
      setOwnProgramsData({});  
  
    }
  });

  useEffect(() => {
    let summaryData = {...database['getAllTimeMarksForClassByDateRange']};   

    // fix a bug in pretests what show more answers correct then answers completed
    if(!isObjectEmpty(summaryData) && summaryData.isLoaded ){
      Object.keys(summaryData.data).map(key => {
          let itemRec = summaryData.data[key];
          let questionsRight=parseInt(itemRec.QuestionsRight);
          let questionsAttempted=parseInt(itemRec.QuestionsAttempted);
          itemRec.QuestionsAttempted = (questionsAttempted > questionsRight)?questionsAttempted:questionsRight;                
      });
    }
    setSummaryRaw(summaryData);
  }, [database['getAllTimeMarksForClassByDateRange']]);   
  
  useEffect(() => {
    let students = {...database['getStudentsForClass']};
    if(database['getStudentsForClass'] && database['getStudentsForClass'].isLoaded){
      students = toArray(database['getStudentsForClass'].data)
       .sort((a,b) => (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : (a.Name.toUpperCase() === b.Name.toUpperCase() ? -1 : 0));
       setStudentData(students);     
    }
  }, [database['getStudentsForClass']]);  

  useEffect(() => {
    if(!classID){ // don't load the classes after they have already been loaded
      let classes = {...database['getAllClasses']};
      deleteThis('getAllTimeMarksForClassByDateRange'); // reload the assignments incase there was interference with another page...
      if(database['getAllClasses'] && database['getAllClasses'].isLoaded){
        classes = toArray(database['getAllClasses'].data)
        .sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() < b.Classname.toUpperCase() ? -1 : 0))
        .map(e=>{e.isSelected=false;return e;});
      }    
      setClassData(classes);
      if(classes.length>0){
        if(isAdmin)
          setClassID(classes[0].ClassID);
        else
          setClassID(sessionStorage.getItem('userID'));
        classes[0].isSelected = true;
      }
    }
  }, [database['getAllClasses']]);    

  useEffect(() => {
    if(!database['getCustomer'])
      return sethasDatabaseData(false);
  },[]);

  if (!hasDatabaseData) {
    return <Redirect to='/' />;
  }

  return (
    (!classID)?<>Please add some classes</>:
    <div>
      <br/>
      <Row>
      <Col xs={12}>
        {(isObjectEmpty(selectedProgram) && isObjectEmpty(selectedStudent))?<>
          <StaticNav currentTopic={'Reports'}/> 
          {isAdmin && <Row style={wizzardBarStyle}> <h5>  &nbsp; 1) Select Your Class </h5></Row>}
          {isAdmin && <ClassSelector pageState={{deleteThis, classID, setClassID, classes:classData}}/>}
          <ProgramSelector pageState={{currentCateg, setCurrentCateg, categsData}} isAdmin={isAdmin} isReports='true'/><br/>

          {(currentCateg ==='Student Marks') && <><Row style={wizzardBarStyle}> <h5>  &nbsp; {isAdmin?3:2}) View Program Reports by Student </h5></Row></>}
          {(currentCateg !=='Student Marks') && <><Row style={wizzardBarStyle}> <h5>  &nbsp; {isAdmin?3:2}) View Student Reports by Program </h5></Row></>}

          {(currentCateg ==='Student Marks') && <MainStudentTableComp pageState={pageState}/>}
          {(currentCateg !=='Student Marks') && <MainProgramTableComp pageState={pageState}/>}
        </>:<>
          {(currentCateg ==='Student Marks') && <ProgramReportTableComp pageState={pageState}/>}
          {(currentCateg !=='Student Marks') && <StudentReportTableComp pageState={pageState}/>}
        </>}
      </Col>
      </Row>
      <br/>

      {/* <ReportWindowModal
          show={modalShow}
          onHide={()=> setModalShow(false)}
        /> */}

    </div>
  );
}

ReportsPage.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  return {
      isAdmin: (state.dashboardReducer.login === 'Admin'),
      database: state.genericReducer,
      programs: convertDictionaryKeys(state.rawProgramReducer.programs, 'id')
 };
};

export default connect(mapStateToProps, { request, deleteThis })(ReportsPage);